import React from 'react';
import {
  Database,
  Cloud,
  BarChart3,
  ExternalLink,
  Lock
} from 'lucide-react';

function ConnectorTypeCard({ connector, onSelect, locked = false }) {
  const getCategoryIcon = (category) => {
    switch (category) {
      case 'database':
        return <Database className="w-6 h-6" />;
      case 'saas':
        return <Cloud className="w-6 h-6" />;
      case 'marketing':
        return <BarChart3 className="w-6 h-6" />;
      default:
        return <ExternalLink className="w-6 h-6" />;
    }
  };

  const getCategoryColor = (category) => {
    switch (category) {
      case 'database':
        return 'text-blue-600 dark:text-blue-400';
      case 'saas':
        return 'text-green-600 dark:text-green-400';
      case 'marketing':
        return 'text-purple-600 dark:text-purple-400';
      default:
        return 'text-gray-600 dark:text-gray-400';
    }
  };

  return (
    <div
      className={`bg-white dark:bg-slate-800 rounded-lg border ${
        locked
          ? 'border-slate-200 dark:border-slate-700 opacity-70 cursor-not-allowed grayscale'
          : 'border-slate-200 dark:border-slate-600 cursor-pointer hover:border-primary-300 dark:hover:border-primary-500 hover:shadow-md transform hover:scale-105'
      } p-6 transition-all duration-200 flex flex-col`}
      onClick={() => !locked && onSelect(connector)}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          {connector.icon_url ? (
            <img
              src={connector.icon_url}
              alt={`${connector.display_name} icon`}
              className="w-8 h-8 rounded"
            />
          ) : (
            <div className={`${getCategoryColor(connector.category)} p-2 bg-gray-100 dark:bg-gray-700 rounded-lg`}>
              {getCategoryIcon(connector.category)}
            </div>
          )}
          <div>
            <h3 className="font-semibold text-slate-900 dark:text-white flex items-center gap-2">
              {connector.display_name}
              {locked && <Lock className="w-4 h-4 text-gray-500 dark:text-gray-400" />}
            </h3>
            <div className="flex gap-2 mt-1">
              <span className="text-xs text-gray-500 dark:text-gray-400 capitalize px-2 py-1 bg-gray-100 dark:bg-gray-700 rounded">
                {connector.category}
              </span>
              {locked && (
                <span className="text-xs text-gray-500 dark:text-gray-400 px-2 py-1 bg-gray-100 dark:bg-gray-700 rounded">
                  Locked
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      <p className="text-sm text-slate-600 dark:text-slate-400 line-clamp-2 mb-4">
        {connector.description}
      </p>

      <div className="mt-auto">
        <div className="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-2">
          {locked && <Lock className="w-4 h-4 text-gray-400" />}
          {locked ? 'Currently unavailable' : `Service: ${connector.service}`}
        </div>
      </div>
    </div>
  );
}

export default ConnectorTypeCard;